import { render, staticRenderFns } from "./Welcome_Default.vue?vue&type=template&id=36629140&scoped=true&"
import script from "./Welcome_Default.vue?vue&type=script&lang=js&"
export * from "./Welcome_Default.vue?vue&type=script&lang=js&"
import style0 from "./Welcome_Default.vue?vue&type=style&index=0&id=36629140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36629140",
  null
  
)

export default component.exports